import React from 'react';
import { Typography } from 'antd';
import styled from 'styled-components';

const HeaderContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    > .ant-typography {
        margin-bottom: 0;
    }
`;

type Props = {
    title: string;
    actions?: React.ReactNode;
    children?: React.ReactNode;
};

export const SidebarHeader = ({ title, actions, children }: Props) => {
    return (
        <HeaderContainer>
            <Typography.Title level={5} className="f-text-medium-content f-text-semibold f-color-dark-black-s100">
                {title}
            </Typography.Title>
            {actions && <div>{actions}</div>}
            {children}
        </HeaderContainer>
    );
};
